import { apiClient } from './auth';

export const ticketsService = {
  async getTickets({ 
    page = 1, 
    pageSize = 10, 
    status = '', 
    search = '', 
    startDate = '', 
    endDate = '',
    parkingId = '',
    zoneId = ''
  }: { 
    page?: number; 
    pageSize?: number; 
    status?: string; 
    search?: string;
    startDate?: string;
    endDate?: string;
    parkingId?: string;
    zoneId?: string;
  }) {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...(status && { status }),
      ...(search && { search: search.trim() }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(parkingId && { parkingId }),
      ...(zoneId && { zoneId }),
    });
    
    // Log pour debug
    console.log('Recherche tickets avec paramètres:', {
      page, pageSize, status, search, startDate, endDate, parkingId, zoneId
    });
    console.log('URL complète:', `/admin/tickets?${params}`);
    
    return apiClient.get(`/admin/tickets?${params}`);
  },

  async getTicket(id: string) {
    return apiClient.get(`/admin/tickets/${id}`);
  },

  async updateTicketStatus(id: string, status: string) {
    return apiClient.patch(`/admin/tickets/${id}/status`, { status });
  },

  async cancelTicket(id: string) {
    return apiClient.delete(`/tickets/admin/${id}/cancel`);
  },
};
